import { render, staticRenderFns } from "./LecturaProcesada.vue?vue&type=template&id=263871f4&"
import script from "@/Servicios/LecturaProcesada.js?vue&type=script&lang=js&"
export * from "@/Servicios/LecturaProcesada.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports